import Loadable from "react-loadable";
import Loading from "../componentes/Loading/Loading";
import { carregaChunk } from "../utils/carregaChunk";

export const NewEditCliente = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Clientes/newEditClientes")),
  loading: Loading as any
});

export const CentralIntegracao = Loadable({
  loader: () => carregaChunk(() => import("./Pages/CentralIntegracao")),
  loading: Loading as any
});

export const NotAllowed = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Error/notAllowed")),
  loading: Loading as any
});

export const Painel = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Painel/painel")),
  loading: Loading as any
});

export const HomeMapped = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Home/home")),
  loading: Loading as any
});

export const AjudaMapped = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Ajuda/ajuda")),
  loading: Loading as any
});

export const AlteraSenhaMapped = Loadable({
  loader: () => carregaChunk(() => import("./Pages/AlteraSenha/alteraSenha")),
  loading: Loading as any
});

export const Relatorios = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Relatorios/relatorios")),
  loading: Loading as any
});

export const NewEditUsuario = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Usuario/newEditUsuario")),
  loading: Loading as any
});

export const NewEditPerfil = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Perfil/newEditPerfil")),
  loading: Loading as any
});

export const NewEditTerminal = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Terminal/newEditTerminal")),
  loading: Loading as any
});

export const NewEditTaxasAntecipacao = Loadable({
  loader: () => carregaChunk(() => import("./Pages/TaxasAntecipacao/newEditTaxasAntecipacao")),
  loading: Loading as any
});

export const FilterConciliacaoEmAberto = Loadable({
  loader: () => carregaChunk(() => import("./Pages/ConciliacaoEmAberto/filterConciliacaoEmAberto")),
  loading: Loading as any
});

export const FilterExtratosOriginais = Loadable({
  loader: () => carregaChunk(() => import("./Pages/ExtratosOriginais/filterExtratosOriginais")),
  loading: Loading as any
});

export const FilterImportacaoTicket = Loadable({
  loader: () => carregaChunk(() => import("./Pages/ImportacaoTicket/filterImportacaoTicket")),
  loading: Loading as any
});

export const Login = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Users/Login")),
  loading: Loading as any
});

export const LoginDedicated = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Standalone/LoginDedicated")),
  loading: Loading as any
});

export const FilterManutencaoArquivosUnico = Loadable({
  loader: () => carregaChunk(() => import("./Pages/manutencaoArquivosUnico/filterManutencaoArquivosUnico")),
  loading: Loading as any
});

export const FilterPesquisaTickets = Loadable({
  loader: () => carregaChunk(() => import("./Pages/PesquisaTicket/filterPesquisaTicket")),
  loading: Loading as any
});

export const NotFound = Loadable({
  loader: () => carregaChunk(() => import("./NotFound/NotFound")),
  loading: Loading as any
});
export const NotFoundDedicated = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Standalone/NotFoundDedicated")),
  loading: Loading as any
});
export const Error = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Error")),
  loading: Loading as any
});
export const Maintenance = Loadable({
  loader: () => carregaChunk(() => import("./Pages/Maintenance")),
  loading: Loading as any
});

export const DashboardGrafico = Loadable({
  loader: () => carregaChunk(() => import("./Pages/DashBoard/dashboardGrafico")),
  loading: Loading as any
});
